import { AppBar, Box, Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component, forwardRef } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MaterialTable from 'material-table';
import Url from 'url';
import join from 'url-join';
import { safeGet } from '../axios-default';
import { ApiServerUrl } from '../config.json';
import { withLang } from '../util/lang';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { getWebAbsPath } from '../util/path';
import { ArrowDownward, ChevronLeft, ChevronRight, FirstPage, LastPage } from '@material-ui/icons';
import QueryString from 'querystring';
import Moment from 'moment/moment';
import Banner from '../components/Banner';

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
        },
    },
    devicesContainer: {
        padding: 16,
        background: '#f2f2f2',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
});

const TabPanel = ({ children, value, index, ...other }) => (
    <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
    >
        {value === index && <Box p={3}>{children}</Box>}
    </Typography>
);

const TabOrdering = [
    { approved: 0, title: 'Waiting for Approval' },
    { approved: 1, title: 'Approved' },
    { approved: -1, title: 'Rejected' },
];

class AppSettingApproval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countriesId2Name: {},
            loading: true,
            tabIndex: 0,
        };
    }

    async componentDidMount() {
        let country = (await safeGet(`res/country`)).country;
        this.setState({
            countriesId2Name: Object.fromEntries(
                Object.entries(country).map(([, { country_id, country_name }]) => [country_id, country_name])
            ),
        });
    }

    render() {
        const { classes } = this.props;
        let dataGetter = [];

        TabOrdering.forEach(
            (v, i) =>
                (dataGetter[v.approved] = async (query) => {
                    const { pageSize, page: pageNo, orderBy, orderDirection } = query;
                    try {
                        const { profile_list, total } = await safeGet(
                            `mobile_app/doctor/profile_approval_list/${v.approved}?${QueryString.encode({
                                pageNo,
                                pageSize,
                                sortBy: orderBy?.field,
                                sortDir: orderDirection,
                            })}`
                        );
                        if (this.state.loading) this.setState({ loading: false });
                        return {
                            data: profile_list,
                            page: pageNo ?? 0,
                            totalCount: total ?? 0,
                        };
                    } catch (err) {
                        console.error(err);
                    }
                })
        );

        return (
            <Animated animationIn="fadeIn" isVisible={!this.state.loading}>
                <Grid container className={classes.devicesContainer}>
                    <Grid item xs={12}>
                        <Banner />
                    </Grid>
                    <Grid item xs={12} style={{ color: 'red' }}>
                        This page is under testing currently. Please do not input or update any information until
                        further notice. Thank you for your kind attention.
                    </Grid>
                </Grid>

                <div className={classes.headerWrapper}>
                    <AppBar position="static" style={{ marginTop: 32 }}>
                        <Tabs
                            variant="fullWidth"
                            value={this.state.tabIndex}
                            onChange={(_, v) => this.setState({ tabIndex: v })}
                            aria-label="nav tabs"
                            className="inkBar"
                            // indicatorColor="primary"
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: '#593687',
                                },
                            }}
                        >
                            {TabOrdering.map((v) => (
                                <Tab label={v.title} />
                            ))}
                        </Tabs>
                    </AppBar>
                </div>

                {TabOrdering.map((v, i) => (
                    <TabPanel value={this.state.tabIndex} index={i}>
                        <Grid container>
                            <Grid item xs={12} md={12} style={{ padding: '24px 16px 24px 8px' }}>
                                <Paper>
                                    <MaterialTable
                                        title={v.title}
                                        columns={[
                                            { title: 'Title', field: 'title' },
                                            { title: 'First Name', field: 'first_name' },
                                            { title: 'Last Name', field: 'last_name' },
                                            {
                                                title: 'Country',
                                                field: 'country_id',
                                                render: (row) => this.state.countriesId2Name[row.country_id],
                                            },
                                            {
                                                title: 'Last Update',
                                                field: 'updated_date',
                                                render: (row) => Moment(row.updated_date).format('DD MMM YYYY'),
                                                defaultSort: 'asc',
                                            },
                                        ]}
                                        data={dataGetter[v.approved]}
                                        onRowClick={(_, data) => {
                                            this.props.history.push(`/appSetting/${data.user_id}`);
                                        }}
                                        options={{
                                            initialPage: 0,
                                            emptyRowsWhenPaging: false,
                                            exportAllData: false,
                                            pageSize: 50,
                                            search: false,
                                            pageSizeOptions: [10, 30, 50, 100],
                                        }}
                                        icons={{
                                            FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
                                            LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
                                            NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                                            PreviousPage: forwardRef((props, ref) => (
                                                <ChevronLeft {...props} ref={ref} />
                                            )),
                                            SortArrow: forwardRef((props, ref) => (
                                                <ArrowDownward {...props} ref={ref} />
                                            )),
                                        }}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                    </TabPanel>
                ))}
            </Animated>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        lang: store.lang,
        config: store.config.config,
    };
};

export default connect(mapStateToProps)(
    withStyles(styles)(withRouter(withLang(AppSettingApproval, 'AppSettingApproval')))
);
